module.exports = __webpack_public_path__ + "img/goldOnlineChange.d2ed4941.png";